export const stripeConnectRef = 'stripe-connect-buy-ref';
export const stripeConnectType = 'stripe-connect-buy';
